module.exports = __webpack_public_path__ + "img/footer.10bec667.png";